module.exports = __webpack_public_path__ + "img/t_0037.40c7abf4.gif";